(function TripSummaryComponentTags($, Adzuki)
{
	'use strict';

	const component = {
		inject: [
			'getFaIconStyle',
		],
		props: {
			formId: {
				type    : String,
				required: true,
			},
			formName: {
				type    : String,
				required: true,
			},
			currentTags: {
				type    : Array,
				default : [],
				required: false,
			},
		},
		template: '#ts-component-tags',
		data() {
			return {
				tagSearch: '',
				tags     : [],
			};
		},
		watch: {
			currentTags(newTags) {
				this.tags = newTags;
			},
		},
		methods: {
			addTag(tag) {
				this.tags.push(tag);
			},
			removeTag(tag) {
				this.tags = this.tags.filter(t => t.id !== tag.id);
			},
		},
		mounted() {
			// init tags typeahead
			Adzuki.Typeahead(this.$refs.tags_search, '/TripSummaryTags/search', async (tag, $self) => {
				// adding a new tag, save it before adding it to the list
				if (tag.id === 'new') {
					const tagName = this.tagSearch.trim();

					this.tagSearch = 'Creating tag...';

					try {
						const response = await Adzuki.Ajax.post('/TripSummaryTags/create', {
							name: tagName,
						});

						if (response.error) {
							return Adzuki.StatusMessage('error', `Error creating tag: ${response.error}`);
						}

						this.addTag({
							id  : response.id,
							name: response.name,
						});
					} catch (error) {
						return Adzuki.StatusMessage('error', `Error creating tag: ${error}`);
					} finally {
						this.tagSearch = '';
					}

					return;
				}

				this.addTag(tag);

				this.tagSearch = '';
			});

			this.tags = this.currentTags;
		},
	};

	Adzuki.VueComponents.TripSummaryComponentTags = component;
}(jQuery, window.Adzuki || {}));
